var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "voice-selector" },
    [
      _c(
        "a-tabs",
        {
          attrs: { "default-active-key": "eleven" },
          on: { change: _vm.handleTabChange },
        },
        [
          _c("a-tab-pane", { key: "eleven", attrs: { tab: "ElevenLabs" } }, [
            _c("div", { staticClass: "voice-list-container" }, [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "loading-container" },
                    [_c("a-spin", { attrs: { tip: "Sesler yükleniyor..." } })],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "voice-list" },
                    [
                      _c(
                        "div",
                        { staticClass: "add-custom-voice-button-wrapper" },
                        [
                          _c(
                            "a-button",
                            {
                              staticClass: "add-custom-voice-button",
                              attrs: { type: "dashed", icon: "plus" },
                              on: {
                                click: function ($event) {
                                  _vm.$feature.beforeCreateVoiceClone(
                                    _vm.showAddCustomVoiceModal,
                                    _vm.getCustomVoiceCount()
                                  )
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("voiceagent.addCustomVoice")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.getFilteredVoices("elevenlabs"),
                          pagination: false,
                          scroll: { y: 400 },
                          "row-key": function (record) {
                            return record.voice_id
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "voice",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "voice-cell" },
                                  [
                                    _c(
                                      "a-avatar",
                                      {
                                        staticClass: "voice-avatar",
                                        attrs: { shape: "square" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getInitials(record.voice_name)
                                          ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "voice-name" }, [
                                      _vm._v(_vm._s(record.voice_name)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "traits",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "traits-cell" },
                                  [
                                    record.accent
                                      ? _c("a-tag", [
                                          _vm._v(_vm._s(record.accent)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    record.gender
                                      ? _c("a-tag", [
                                          _vm._v(_vm._s(record.gender)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    record.age
                                      ? _c("a-tag", [
                                          _vm._v(_vm._s(record.age)),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "voiceId",
                            fn: function (text, record) {
                              return [
                                _c("div", { staticClass: "voice-id-cell" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(record.voice_id) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "options",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "options-cell" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          disabled:
                                            _vm.isCurrentlySelected(record),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectVoice(record)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.isCurrentlySelected(record)
                                                ? "Seçili"
                                                : "Seç"
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          type: "default",
                                          size: "small",
                                          disabled: !record.preview_audio_url,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.previewVoice(record)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("volume_up")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
            ]),
          ]),
          _vm._v(" "),
          _c("a-tab-pane", { key: "openai", attrs: { tab: "OpenAI" } }, [
            _c("div", { staticClass: "voice-list-container" }, [
              _vm.loading
                ? _c(
                    "div",
                    { staticClass: "loading-container" },
                    [_c("a-spin", { attrs: { tip: "Sesler yükleniyor..." } })],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "voice-list" },
                    [
                      _c("a-table", {
                        attrs: {
                          columns: _vm.columns,
                          "data-source": _vm.getFilteredVoices("openai"),
                          pagination: false,
                          scroll: { y: 400 },
                          "row-key": function (record) {
                            return record.voice_id
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "voice",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "voice-cell" },
                                  [
                                    _c(
                                      "a-avatar",
                                      {
                                        staticClass: "voice-avatar",
                                        attrs: { shape: "square" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getInitials(record.voice_name)
                                          ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "voice-name" }, [
                                      _vm._v(_vm._s(record.voice_name)),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "traits",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "traits-cell" },
                                  [
                                    record.accent
                                      ? _c("a-tag", [
                                          _vm._v(_vm._s(record.accent)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    record.gender
                                      ? _c("a-tag", [
                                          _vm._v(_vm._s(record.gender)),
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    record.age
                                      ? _c("a-tag", [
                                          _vm._v(_vm._s(record.age)),
                                        ])
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "voiceId",
                            fn: function (text, record) {
                              return [
                                _c("div", { staticClass: "voice-id-cell" }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(record.voice_id) +
                                      "\n                            "
                                  ),
                                ]),
                              ]
                            },
                          },
                          {
                            key: "options",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "options-cell" },
                                  [
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                          disabled:
                                            _vm.isCurrentlySelected(record),
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectVoice(record)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.isCurrentlySelected(record)
                                                ? "Seçili"
                                                : "Seç"
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-button",
                                      {
                                        attrs: {
                                          type: "default",
                                          size: "small",
                                          disabled: !record.preview_audio_url,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.previewVoice(record)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("volume_up")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("audio", { ref: "audioPlayer", staticStyle: { display: "none" } }),
      _vm._v(" "),
      _vm.isAddCustomVoiceModalVisible
        ? _c(
            "modal2",
            {
              staticClass: "custom-voice-modal",
              attrs: { title: "Add Custom Voice", showFooter: false },
              on: { cancel: _vm.closeAddCustomVoiceModal },
            },
            [
              _c(
                "div",
                { staticClass: "custom-voice-modal" },
                [
                  _c(
                    "a-tabs",
                    {
                      model: {
                        value: _vm.customVoiceTab,
                        callback: function ($$v) {
                          _vm.customVoiceTab = $$v
                        },
                        expression: "customVoiceTab",
                      },
                    },
                    [
                      _c(
                        "a-tab-pane",
                        { key: "voice-clone", attrs: { tab: "Voice Clone" } },
                        [
                          _c("div", { staticClass: "voice-clone-container" }, [
                            _c("h3", [_vm._v("Ses Klonlama")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "30 saniyelik bir ses kaydı yükleyerek kendi sesinizi klonlayabilirsiniz."
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "voice-name-input" },
                              [
                                _c("label", [_vm._v("Voice Name")]),
                                _vm._v(" "),
                                _c("a-input", {
                                  attrs: { placeholder: "Enter a voice name" },
                                  model: {
                                    value: _vm.voiceCloneData.voiceName,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.voiceCloneData,
                                        "voiceName",
                                        $$v
                                      )
                                    },
                                    expression: "voiceCloneData.voiceName",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "upload-container" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "upload-dropzone",
                                  on: {
                                    dragover: function ($event) {
                                      $event.preventDefault()
                                    },
                                    drop: function ($event) {
                                      $event.preventDefault()
                                      return _vm.onFileDrop.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    click: _vm.triggerFileInput,
                                  },
                                },
                                [
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons upload-icon",
                                    },
                                    [_vm._v("cloud_upload")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "upload-text" }, [
                                    _vm._v(
                                      "Choose a file or drag & drop it here."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "upload-details" }, [
                                    _vm._v(
                                      "Audio and video formats, up to 10 MB."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "fileInput",
                                    staticStyle: { display: "none" },
                                    attrs: {
                                      type: "file",
                                      accept: "audio/*,video/*",
                                    },
                                    on: { change: _vm.onFileChange },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "record-option" },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: {
                                        type: "default",
                                        danger: _vm.isRecording,
                                      },
                                      on: { click: _vm.toggleRecording },
                                    },
                                    [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.isRecording ? "stop" : "mic"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(
                                            _vm.isRecording
                                              ? "Kaydı Durdur"
                                              : "Mikrofondan Kaydet"
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.recordingTime > 0
                                    ? _c(
                                        "span",
                                        { staticClass: "recording-timer" },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.formatRecordingTime(
                                                  _vm.recordingTime
                                                )
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.recordedAudio
                                ? _c("div", { staticClass: "recorded-audio" }, [
                                    _c("div", { staticClass: "file-info" }, [
                                      _c(
                                        "i",
                                        { staticClass: "material-icons" },
                                        [_vm._v("audio_file")]
                                      ),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          "Mikrofon Kaydı (" +
                                            _vm._s(
                                              _vm.formatRecordingTime(
                                                _vm.recordingTime
                                              )
                                            ) +
                                            ")"
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "audio-controls" },
                                      [
                                        _c(
                                          "a-button",
                                          {
                                            attrs: { type: "link" },
                                            on: {
                                              click: _vm.playRecordedAudio,
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("play_arrow")]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-button",
                                          {
                                            attrs: { type: "link" },
                                            on: {
                                              click: _vm.removeRecordedAudio,
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("close")]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.voiceCloneData.audioFile &&
                              !_vm.voiceCloneData._isFromRecording
                                ? _c(
                                    "div",
                                    { staticClass: "selected-file" },
                                    [
                                      _c("div", { staticClass: "file-info" }, [
                                        _c(
                                          "i",
                                          { staticClass: "material-icons" },
                                          [_vm._v("audio_file")]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.voiceCloneData.audioFile.name
                                            )
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "a-button",
                                        {
                                          attrs: { type: "link" },
                                          on: { click: _vm.removeSelectedFile },
                                        },
                                        [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("close")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "terms-checkbox" },
                              [
                                _c(
                                  "a-checkbox",
                                  {
                                    model: {
                                      value: _vm.voiceCloneData.termsAccepted,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.voiceCloneData,
                                          "termsAccepted",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "voiceCloneData.termsAccepted",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Yüklediğim ve klonladığım ses örnekleri için gerekli tüm haklara veya izinlere sahip\n                                olduğumu, platform tarafından oluşturulan içeriği herhangi bir yasa dışı,\n                                dolandırıcılık veya zararlı amaçla kullanmayacağımı onaylıyorum. Ünlülerin, devlet\n                                yetkililerinin veya izinsiz üçüncü şahısların seslerini klonlamanın suç teşkil\n                                edebileceğini anlıyor ve kabul ediyorum.\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "actions" },
                              [
                                _c(
                                  "a-button",
                                  {
                                    on: { click: _vm.closeAddCustomVoiceModal },
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      disabled: !_vm.canSubmitVoiceClone,
                                      loading: _vm.isSubmitting,
                                    },
                                    on: { click: _vm.submitVoiceClone },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Save\n                            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-tab-pane",
                        {
                          key: "community-voices",
                          attrs: { tab: "Community Voices" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "community-voices-container" },
                            [
                              _c("h3", [_vm._v("Topluluk Seslerini Ara")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "Topluluk tarafından oluşturulmuş sesleri arayıp kullanabilirsiniz."
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "search-container" },
                                [
                                  _c("a-input-search", {
                                    attrs: {
                                      placeholder: "Ara...",
                                      "enter-button": "",
                                    },
                                    on: { search: _vm.searchCommunityVoices },
                                    model: {
                                      value: _vm.communitySearchQuery,
                                      callback: function ($$v) {
                                        _vm.communitySearchQuery = $$v
                                      },
                                      expression: "communitySearchQuery",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.isSearching
                                ? _c(
                                    "div",
                                    { staticClass: "loading-container" },
                                    [
                                      _c("a-spin", {
                                        attrs: { tip: "Aranıyor..." },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.communityVoices.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "community-voices-results" },
                                    [
                                      _c("a-list", {
                                        attrs: {
                                          "item-layout": "horizontal",
                                          "data-source": _vm.communityVoices,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "renderItem",
                                              fn: function (voice) {
                                                return _c(
                                                  "a-list-item",
                                                  { key: voice.voice_id },
                                                  [
                                                    _c(
                                                      "a-list-item-meta",
                                                      {
                                                        attrs: {
                                                          description:
                                                            _vm.getCommunityVoiceDescription(
                                                              voice
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            attrs: {
                                                              slot: "title",
                                                            },
                                                            slot: "title",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                voice.name
                                                              ) + " "
                                                            ),
                                                            _c("a-tag", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  voice.accent
                                                                )
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "list-item-actions",
                                                      },
                                                      [
                                                        _c(
                                                          "a-button",
                                                          {
                                                            attrs: {
                                                              type: "default",
                                                              size: "small",
                                                              disabled:
                                                                !voice.preview_url,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.previewCommunityVoice(
                                                                  voice
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "volume_up"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "a-button",
                                                          {
                                                            attrs: {
                                                              type: "primary",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.selectCommunityVoice(
                                                                  voice
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                            Seç\n                                        "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2472751151
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm.hasSearched
                                ? _c("div", { staticClass: "no-results" }, [
                                    _c("p", [
                                      _vm._v(
                                        "Aramanıza uygun ses bulunamadı. Lütfen başka bir arama terimi deneyin."
                                      ),
                                    ]),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "actions" },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      on: {
                                        click: _vm.closeAddCustomVoiceModal,
                                      },
                                    },
                                    [_vm._v("İptal")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }